import React, { createContext, useContext, useEffect, useState } from 'react';

const ProjectContext = createContext(null);

export const ProjectProvider = ({ children }) => {
  const [tracks, setTracks] = useState(() => {
    try { return JSON.parse(localStorage.getItem('capcute_tracks') || '[]'); } catch { return []; }
  });
  const [templates, setTemplates] = useState(() => {
    try { return JSON.parse(localStorage.getItem('capcute_templates') || '[]'); } catch { return []; }
  });

  useEffect(() => { localStorage.setItem('capcute_tracks', JSON.stringify(tracks)); }, [tracks]);
  useEffect(() => { localStorage.setItem('capcute_templates', JSON.stringify(templates)); }, [templates]);

  const addTrack = (track) => setTracks(prev => prev.find(t => t.id === track.id) ? prev : [...prev, track]);
  const removeTrack = (id) => setTracks(prev => prev.filter(t => t.id !== id));
  const addTemplate = (tpl) => setTemplates(prev => prev.find(t => t.id === tpl.id) ? prev : [...prev, tpl]);

  return (
    <ProjectContext.Provider value={{ tracks, templates, addTrack, removeTrack, addTemplate }}>
      {children}
    </ProjectContext.Provider>
  );
};

export const useProject = () => {
  const ctx = useContext(ProjectContext);
  if (!ctx) throw new Error('useProject must be used inside ProjectProvider');
  return ctx;
};
